import { render, staticRenderFns } from "./PushBoxItem.vue?vue&type=template&id=50bc6e1e&"
import script from "./PushBoxItem.vue?vue&type=script&lang=js&"
export * from "./PushBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports